<template lang="html">


    <div class="container-fluid">

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate
                                 size="64">

            </v-progress-circular>
        </v-overlay>
        <div v-if="previewsColisiones && !previewsRobo && !previewsRlv">
            <div class="my-2 mx-1">
                <v-btn color="error" @click="regresar()" dark dense>
                    <v-icon left>
                        mdi-keyboard-backspace
                    </v-icon>
                    Regresar
                </v-btn>
            </div>

            <v-row v-if="tipo == 1">
                <v-col lg=12 cols=12 style="margin: 0 auto;">
                    <v-card class=" mx-1 pt-2 primary">
                        <div class="d-flex justify-space-between align-center px-4">
                            <v-list-item-title class="text-h5 mb-1 white--text" style="text-align: center;">
                                Colisiones Mayores
                            </v-list-item-title>

                            <div v-if="loadingExcel == false">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-on="on" v-bind="attrs"
                                               class="btnAbo" icon fab @click="DescargarExcel(2)">
                                            <v-icon color="white" dark style="cursor: pointer !important" class="hover">
                                                mdi-file-excel-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Descargar Excel</span>
                                </v-tooltip>
                            </div>

                            <v-progress-circular v-else
                                                 color="white"
                                                 indeterminate
                                                 size="24"></v-progress-circular>
                        </div>


                    </v-card>
                </v-col>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidios != 0"
                                        class="wrexlink" @click="previstaColisiones(1)"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresHomicidios }}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidios == 0"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresHomicidios }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="red">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidios != 0"
                                        class="wrexlink" @click="previstaColisiones(1)" style="font-size: 16px;  ">
                                        Homicidios
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidios == 0"
                                        style="font-size: 16px;  ">
                                        Homicidios
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesiones != 0" class="wrexlink"
                                        @click="previstaColisiones(2)" style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresLesiones }}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesiones == 0"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresLesiones }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="blue">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesiones != 0" class="wrexlink"
                                        @click="previstaColisiones(2)" style="font-size: 16px;  ">
                                        Lesiones
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesiones == 0"
                                        style="font-size: 16px;  ">
                                        Lesiones
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayoresDanios != 0" class="wrexlink"
                                        @click="previstaColisiones(3)" style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresDanios }}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDanios == 0"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresDanios }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="yellow">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDanios != 0" class="wrexlink"
                                        @click="previstaColisiones(3)" style="font-size: 16px;  ">
                                        Daños
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDanios == 0"
                                        style="font-size: 16px;  ">
                                        Daños
                                    </span>
                                </v-row>

                            </v-col>
                        </v-row>


                        <br />

                    </v-card>

                </v-col>
            </v-row>

            <v-row v-if="tipo == 2">
                <v-col lg=12 cols=12 style="margin: 0 auto;">
                    <v-card class=" mx-1 pt-2 primary">
                      
                        <div class="d-flex justify-space-between align-center px-4">
                            <v-list-item-title class="text-h5 mb-1 white--text" style="text-align: center;">
                                Colisiones Menores
                            </v-list-item-title>

                            <div v-if="loadingExcel == false">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-on="on" v-bind="attrs"
                                               class="btnAbo" icon fab @click="DescargarExcel(6)">
                                            <v-icon color="white" dark style="cursor: pointer !important" class="hover">
                                                mdi-file-excel-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Descargar Excel</span>
                                </v-tooltip>
                            </div>

                            <v-progress-circular v-else
                                                 color="white"
                                                 indeterminate
                                                 size="24"></v-progress-circular>
                        </div>

                    </v-card>
                </v-col>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMenoresJuicios != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMenores(3, 'Juicios Orales', 'Colisiones-Menores')"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMenoresJuicios }}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMenoresJuicios == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMenoresJuicios }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="blue">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMenoresJuicios != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMenores(3, 'Juicios Orales', 'Colisiones-Menores')"
                                        style="font-size: 16px;  ">
                                        Juicios Orales
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMenoresJuicios == 0 || !permiso"
                                        style="font-size: 16px;  ">
                                        Juicios Orales
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMenoresAve != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMenores(4, 'Averiguación Previa', 'Colisiones-Menores')"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMenoresAve }}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMenoresAve == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMenoresAve }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="red">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMenoresAve != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMenores(4, 'Averiguación Previa', 'Colisiones-Menores')"
                                        style="font-size: 16px;  ">
                                        Averiguación Previa
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMenoresAve == 0 || !permiso"
                                        style="font-size: 16px;  ">
                                        Averiguación Previa
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMenoresJuez != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMenores(2, 'Juez Cívico Conciliador', 'Colisiones-Menores')"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMenoresJuez }}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMenoresJuez == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMenoresJuez }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="yellow">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMenoresJuez != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMenores(2, 'Juez Cívico Conciliador', 'Colisiones-Menores')"
                                        style="font-size: 16px;  ">
                                        Juez Cívico Conciliador
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMenoresJuez == 0 || !permiso"
                                        style="font-size: 16px;  ">
                                        Juez Cívico Conciliador
                                    </span>
                                </v-row>

                            </v-col>
                        </v-row>


                        <br />

                    </v-card>

                </v-col>
            </v-row>





            <v-row v-if="tipo == 3 && !previewsRobo">
                <v-col lg=12 cols=12 style="margin: 0 auto;">
                    <v-card class=" mx-1 pt-2 primary">
                        <div class="d-flex justify-space-between align-center px-4">
                            <v-list-item-title class="text-h5 mb-1 white--text" style="text-align: center;">
                                Robos Recuperados
                            </v-list-item-title>

                            <div v-if="loadingExcel == false">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-on="on" v-bind="attrs"
                                               class="btnAbo" icon fab @click="DescargarExcelRobo(3)">
                                            <v-icon color="white" dark style="cursor: pointer !important" class="hover">
                                                mdi-file-excel-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Descargar Excel</span>
                                </v-tooltip>
                            </div>

                            <v-progress-circular v-else
                                                 color="white"
                                                 indeterminate
                                                 size="24"></v-progress-circular>
                        </div>

                    </v-card>
                </v-col>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="6" sm="6">
                                <v-row justify="center">
                                    <span v-if="dataPendientesRobo.RobosRecuperadosVhDetenidos != 0 && permiso"
                                        class="wrexlink" @click="vistaRobovedet()"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesRobo.RobosRecuperadosVhDetenidos }}
                                    </span>
                                    <span v-if="dataPendientesRobo.RobosRecuperadosVhDetenidos == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesRobo.RobosRecuperadosVhDetenidos }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="blue">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesRobo.RobosRecuperadosVhDetenidos != 0 && permiso"
                                        class="wrexlink" @click="vistaRobovedet()" style="font-size: 16px;  ">
                                        Vehículos Detenidos
                                    </span>
                                    <span v-if="dataPendientesRobo.RobosRecuperadosVhDetenidos == 0 || !permiso"
                                        style="font-size: 16px;  ">
                                        Vehículos Detenidos
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="6" sm="6">
                                <v-row justify="center">
                                    <span style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesRobo.RobosRecuperadosVhLiberados }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="red">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span style="font-size: 16px;  ">
                                        Vehículos Liberados
                                    </span>
                                </v-row>
                            </v-col>
                        </v-row>


                        <br />

                    </v-card>

                </v-col>
            </v-row>


            <v-row v-if="tipo == 4">
                <v-col lg=12 cols=12 style="margin: 0 auto;">
                    <v-card class=" mx-1 pt-2 primary">
                        <div class="d-flex justify-space-between align-center px-4">
                            <v-list-item-title class="text-h5 mb-1 white--text" style="text-align: center;">
                                Vehículos Detenidos
                            </v-list-item-title>

                            <div v-if="loadingExcel == false">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-on="on" v-bind="attrs"
                                               class="btnAbo" icon fab @click="DescargarExcelVH()">
                                            <v-icon color="white" dark style="cursor: pointer !important" class="hover">
                                                mdi-file-excel-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Descargar Excel</span>
                                </v-tooltip>
                            </div>

                            <v-progress-circular v-else
                                                 color="white"
                                                 indeterminate
                                                 size="24"></v-progress-circular>
                        </div>

                    </v-card>
                </v-col>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="3" sm="3">
                                <v-row justify="center">
                                    <span v-if="dataVhDetenidos.Vehiculosatiempo != 0 && permiso" class="wrexlink"
                                        @click="generarTableroVHDetenidos(1, 'Liberación de Vehículo', 'Veh-A tiempo', 1, '1,24,23')"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataVhDetenidos.Vehiculosatiempo }}
                                    </span>
                                    <span v-if="dataVhDetenidos.Vehiculosatiempo == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataVhDetenidos.Vehiculosatiempo }}
                                    </span>

                                </v-row>
                                <v-row justify="center">

                                    <span style="font-size: 25px; color:#3364FF">
                                        {{ dataVhDetenidos.Porcentaje1 }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon x-large color="#01b8aa">
                                        mdi-clock
                                    </v-icon>
                                    <span v-if="dataVhDetenidos.Vehiculosatiempo != 0 && permiso" class="wrexlink"
                                        @click="generarTableroVHDetenidos(1, 'Liberación de Vehículo', 'Veh-A tiempo', 1, '1,24,23')"
                                        style="font-size: 16px;  margin-top: 10px;   margin-left: 10px; ">
                                        Vehículos a tiempo
                                    </span>
                                    <span v-if="dataVhDetenidos.Vehiculosatiempo == 0 || !permiso"
                                        style="font-size: 16px;  margin-top: 10px;   margin-left: 10px; ">
                                        Vehículos a tiempo
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="3" sm="3">
                                <v-row justify="center">
                                    <span v-if="dataVhDetenidos.Vehiculoslimite != 0 && permiso" class="wrexlink"
                                        @click="generarTableroVHDetenidos(1, 'Liberación de Vehículo', 'Veh-Al límite', 2, '1,24,23')"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataVhDetenidos.Vehiculoslimite }}
                                    </span>
                                    <span v-if="dataVhDetenidos.Vehiculoslimite == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataVhDetenidos.Vehiculoslimite }}
                                    </span>

                                </v-row>
                                <v-row justify="center">

                                    <span style="font-size: 25px; color:#3364FF">
                                        {{ dataVhDetenidos.Porcentaje2 }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon x-large color="#f2c80f">
                                        mdi-progress-clock
                                    </v-icon>
                                    <span v-if="dataVhDetenidos.Vehiculoslimite != 0 && permiso" class="wrexlink"
                                        @click="generarTableroVHDetenidos(1, 'Liberación de Vehículo', 'Veh-Al límite', 2, '1,24,23')"
                                        style="font-size: 16px; margin-top: 10px;   margin-left: 10px;  ">
                                        Vehículos al limite
                                    </span>
                                    <span v-if="dataVhDetenidos.Vehiculoslimite == 0 || !permiso"
                                        style="font-size: 16px;  margin-top: 10px;   margin-left: 10px; ">
                                        Vehículos al limite
                                    </span>
                                </v-row>
                            </v-col>

                            <v-col cols="3" sm="3">
                                <v-row justify="center">

                                    <span v-if="dataVhDetenidos.VehiculosFueraTiempo15 != 0 && permiso" class="wrexlink"
                                        @click="generarTableroVHDetenidos(1, 'Liberación de Vehículo', 'Veh-Fuera 15 días', 3, '1,24,23')"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataVhDetenidos.VehiculosFueraTiempo15 }}
                                    </span>
                                    <span v-if="dataVhDetenidos.VehiculosFueraTiempo15 == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataVhDetenidos.VehiculosFueraTiempo15 }}
                                    </span>
                                </v-row>
                                <v-row justify="center">

                                    <span style="font-size: 25px; color:#3364FF">
                                        {{ dataVhDetenidos.Porcentaje3 }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon x-large color="#fe9666">
                                        mdi-progress-clock
                                    </v-icon>
                                    <span v-if="dataVhDetenidos.VehiculosFueraTiempo15 != 0 && permiso" class="wrexlink"
                                        @click="generarTableroVHDetenidos(1, 'Liberación de Vehículo', 'Veh-Fuera 15 días', 3, '1,24,23')"
                                        style="font-size: 16px; margin-top: 10px;   margin-left: 10px;  ">
                                        Vehículos fuera de tiempo < 15 dias </span>
                                            <span v-if="dataVhDetenidos.VehiculosFueraTiempo15 == 0 || !permiso"
                                                style="font-size: 16px; margin-top: 10px;   margin-left: 10px;  ">
                                                Vehículos fuera de tiempo < 15 dias </span>
                                </v-row>
                            </v-col>
                            <v-col cols="3" sm="3">
                                <v-row justify="center">
                                    <span v-if="dataVhDetenidos.Vehiculosfueratiempo != 0 && permiso" class="wrexlink"
                                        @click="generarTableroVHDetenidos(1, 'Liberación de Vehículo', 'Veh-Fuera de tiempo', 4, '1,24,23')"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataVhDetenidos.Vehiculosfueratiempo }}
                                    </span>
                                    <span v-if="dataVhDetenidos.Vehiculosfueratiempo == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataVhDetenidos.Vehiculosfueratiempo }}
                                    </span>

                                </v-row>
                                <v-row justify="center">

                                    <span style="font-size: 25px; color:#3364FF">
                                        {{ dataVhDetenidos.Porcentaje4 }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon x-large color="#fd625e">
                                        mdi-clock-alert
                                    </v-icon>
                                    <span v-if="dataVhDetenidos.Vehiculosfueratiempo != 0 && permiso" class="wrexlink"
                                        @click="generarTableroVHDetenidos(1, 'Liberación de Vehículo', 'Veh-Fuera de tiempo', 4, '1,24,23')"
                                        style="font-size: 16px; margin-top: 10px;   margin-left: 10px;   ">
                                        Vehículos fuera de tiempo
                                    </span>
                                    <span v-if="dataVhDetenidos.Vehiculosfueratiempo == 0 || !permiso"
                                        style="font-size: 16px; margin-top: 10px;   margin-left: 10px;  ">
                                        Vehículos fuera de tiempo
                                    </span>
                                </v-row>
                            </v-col>

                        </v-row>

                        <br />

                    </v-card>

                </v-col>
            </v-row>
            <!--  nuevo -->
            <v-row v-if="tipo == 4">
                <v-col lg=6 sm=12 md=6 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataVhDetenidos.CatastroficosVehTiempo != 0 && permiso" class="wrexlink"
                                          @click="generarTableroVHDetenidos(1, 'Liberación de Vehículo', 'Veh a tiempo Homicidios-Lesiones', 5, '1,24,23')"
                                          style="font-size: 50px; color:#3364FF">
                                        {{ dataVhDetenidos.CatastroficosVehTiempo }}
                                    </span>
                                    <span v-if="dataVhDetenidos.CatastroficosVehTiempo == 0 || !permiso"
                                          style="font-size: 50px; color:#3364FF">
                                        {{ dataVhDetenidos.CatastroficosVehTiempo }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 25px; color:#3364FF">
                                        {{ dataVhDetenidos.Porcentaje5 }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <div v-if="dataVhDetenidos.CatastroficosVehTiempo != 0 && permiso" class="wrexlink"
                                          @click="generarTableroVHDetenidos(1, 'Liberación de Vehículo', 'Veh a tiempo Homicidios-Lesiones', 5, '1,24,23')"
                                          style="font-size: 16px; margin-top: 10px; margin-left: 10px; text-align: center;">
                                        Homicidios-Lesiones
                                    </div>
                                    <div v-if="dataVhDetenidos.CatastroficosVehTiempo == 0 || !permiso"
                                         style="font-size: 16px; margin-top: 10px; margin-left: 10px; text-align: center;">
                                        Homicidios-Lesiones
                                    </div>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataVhDetenidos.MenoresVehTiempoRLV != 0 && permiso" class="wrexlink"
                                          @click="generarTableroVHDetenidos(1, 'Liberación de Vehículo', 'RLV', 6, '23')"
                                          style="font-size: 50px; color:#3364FF">
                                        {{ dataVhDetenidos.MenoresVehTiempoRLV }}
                                    </span>
                                    <span v-if="dataVhDetenidos.MenoresVehTiempoRLV == 0 || !permiso"
                                          style="font-size: 50px; color:#3364FF">
                                        {{ dataVhDetenidos.MenoresVehTiempoRLV }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 25px; color:#3364FF">
                                        {{ dataVhDetenidos.Porcentaje9 }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span v-if="dataVhDetenidos.MenoresVehTiempoRLV != 0 && permiso" class="wrexlink"
                                          @click="generarTableroVHDetenidos(1, 'Liberación de Vehículo', 'RLV', 6, '23')"
                                          style="font-size: 16px; margin-top: 10px;   margin-left: 10px;  ">
                                        RLV
                                    </span>
                                    <span v-if="dataVhDetenidos.MenoresVehTiempoRLV == 0 || !permiso"
                                          style="font-size: 16px;  margin-top: 10px;   margin-left: 10px; ">
                                        RLV
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataVhDetenidos.MenoresVehTiempo != 0 && permiso" class="wrexlink"
                                          @click="generarTableroVHDetenidos(1, 'Liberación de Vehículo', 'Veh a tiempo Robos-Daños', 6, '1,24')"
                                          style="font-size: 50px; color:#3364FF">
                                        {{ dataVhDetenidos.MenoresVehTiempo }}
                                    </span>
                                    <span v-if="dataVhDetenidos.MenoresVehTiempo == 0 || !permiso"
                                          style="font-size: 50px; color:#3364FF">
                                        {{ dataVhDetenidos.MenoresVehTiempo }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 25px; color:#3364FF">
                                        {{ dataVhDetenidos.Porcentaje6 }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <div v-if="dataVhDetenidos.MenoresVehTiempo != 0 && permiso" class="wrexlink"
                                         @click="generarTableroVHDetenidos(1, 'Liberación de Vehículo', 'Veh a tiempo Robos-Daños', 6, '1,24')"
                                         style="font-size: 16px; margin-top: 10px; margin-left: 10px; text-align: center;">
                                        Robos-Daños
                                    </div>
                                    <div v-if="dataVhDetenidos.MenoresVehTiempo == 0 || !permiso"
                                          style="font-size: 16px; margin-top: 10px; margin-left: 10px; text-align: center;">
                                        Robos-Daños
                                    </div>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-icon x-large color="#01b8aa">
                                mdi-clock
                            </v-icon>
                            <span style="font-size: 16px;  margin-top: 10px;   margin-left: 10px; ">
                                Vehículos a tiempo
                            </span>
                        </v-row>
                        <br />
                    </v-card>
                </v-col>
                <v-col lg=6 sm=12 md=6 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataVhDetenidos.CatastroficosVehFueraTiempo != 0 && permiso"
                                          class="wrexlink"
                                          @click="generarTableroVHDetenidos(1, 'Liberación de Vehículo', 'Veh fuera de tiempo Homicidios-Lesiones', 7, '1,24,23')"
                                          style="font-size: 50px; color:#3364FF">
                                        {{ dataVhDetenidos.CatastroficosVehFueraTiempo }}
                                    </span>
                                    <span v-if="dataVhDetenidos.CatastroficosVehFueraTiempo == 0 || !permiso"
                                          style="font-size: 50px; color:#3364FF">
                                        {{ dataVhDetenidos.CatastroficosVehFueraTiempo }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 25px; color:#3364FF">
                                        {{ dataVhDetenidos.Porcentaje7 }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <div v-if="dataVhDetenidos.CatastroficosVehFueraTiempo != 0 && permiso"
                                         class="wrexlink"
                                         @click="generarTableroVHDetenidos(1, 'Liberación de Vehículo', 'Veh fuera de tiempo Homicidios-Lesiones', 7, '1,24,23')"
                                         style="font-size: 16px; margin-top: 10px; margin-left: 10px; text-align: center;">
                                        Homicidios-Lesiones
                                    </div>
                                    <div v-if="dataVhDetenidos.CatastroficosVehFueraTiempo == 0 || !permiso"
                                         style="font-size: 16px; margin-top: 10px; margin-left: 10px; text-align: center;">
                                        Homicidios-Lesiones
                                    </div>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataVhDetenidos.MenoresVehFueraTiempoRLV != 0 && permiso" class="wrexlink"
                                          @click="generarTableroVHDetenidos(1, 'Liberación de Vehículo', 'RLV', 8, '23')"
                                          style="font-size: 50px; color:#3364FF">
                                        {{ dataVhDetenidos.MenoresVehFueraTiempoRLV }}
                                    </span>
                                    <span v-if="dataVhDetenidos.MenoresVehFueraTiempoRLV == 0 || !permiso"
                                          style="font-size: 50px; color:#3364FF">
                                        {{ dataVhDetenidos.MenoresVehFueraTiempoRLV }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 25px; color:#3364FF">
                                        {{ dataVhDetenidos.Porcentaje10 }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span v-if="dataVhDetenidos.MenoresVehFueraTiempoRLV != 0 && permiso" class="wrexlink"
                                          @click="generarTableroVHDetenidos(1, 'Liberación de Vehículo', 'RLV', 8, '23')"
                                          style="font-size: 16px; margin-top: 10px;   margin-left: 10px;  ">
                                        RLV
                                    </span>
                                    <span v-if="dataVhDetenidos.MenoresVehFueraTiempoRLV == 0 || !permiso"
                                          style="font-size: 16px;  margin-top: 10px;   margin-left: 10px; ">
                                        RLV
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataVhDetenidos.MenoresVehFueraTiempo != 0 && permiso" class="wrexlink"
                                          @click="generarTableroVHDetenidos(1, 'Liberación de Vehículo', 'Veh fuera de tiempo Robos-Daños', 8, '1,24')"
                                          style="font-size: 50px; color:#3364FF">
                                        {{ dataVhDetenidos.MenoresVehFueraTiempo }}
                                    </span>
                                    <span v-if="dataVhDetenidos.MenoresVehFueraTiempo == 0 || !permiso"
                                          style="font-size: 50px; color:#3364FF">
                                        {{ dataVhDetenidos.MenoresVehFueraTiempo }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 25px; color:#3364FF">
                                        {{ dataVhDetenidos.Porcentaje8 }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <div v-if="dataVhDetenidos.MenoresVehFueraTiempo != 0 && permiso" class="wrexlink"
                                         @click="generarTableroVHDetenidos(1, 'Liberación de Vehículo', 'Veh fuera de tiempo Robos-Daños', 8, '1,24')"
                                         style="font-size: 16px; margin-top: 10px; margin-left: 10px; text-align: center;">
                                        Robos-Daños
                                    </div>
                                    <div v-if="dataVhDetenidos.MenoresVehFueraTiempo == 0 || !permiso"
                                         style="font-size: 16px; margin-top: 10px; margin-left: 10px; text-align: center;">
                                        Robos-Daños
                                    </div>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-icon x-large color="#fd625e">
                                mdi-clock-alert
                            </v-icon>
                            <span style="font-size: 16px; margin-top: 10px;   margin-left: 10px;  ">
                                Vehículos fuera de tiempo
                            </span>
                        </v-row>
                        <br />
                    </v-card>
                </v-col>
            </v-row>
            <!-- Termina lo nuevo -->
            <!-- ///Proceso de robos denuncias -->
            <v-row v-if="tipo == 5">
                <v-col lg=12 cols=12 style="margin: 0 auto;">
                    <v-card class=" mx-1 pt-2 primary">
                        <div class="d-flex justify-space-between align-center px-4">
                            <v-list-item-title class="text-h5 mb-1 white--text" style="text-align: center;">
                                Robo solo denuncias
                            </v-list-item-title>

                            <div v-if="loadingExcel == false">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-on="on" v-bind="attrs"
                                               class="btnAbo" icon fab @click="DescargarExcelRobo(2)">
                                            <v-icon color="white" dark style="cursor: pointer !important" class="hover">
                                                mdi-file-excel-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Descargar Excel</span>
                                </v-tooltip>
                            </div>

                            <v-progress-circular v-else
                                                 color="white"
                                                 indeterminate
                                                 size="24"></v-progress-circular>
                        </div>

                    </v-card>
                </v-col>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="3" sm="3">
                                <v-row justify="center">
                                    <span v-if="dataPendientesRobo.RobosDenunciasBanda1 != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroRobosDenuncias(5, 'Robo', 'Solo Denuncias-A Tiempo', 1)"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesRobo.RobosDenunciasBanda1 }}
                                    </span>
                                    <span v-if="dataPendientesRobo.RobosDenunciasBanda1 == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesRobo.RobosDenunciasBanda1 }}
                                    </span>

                                </v-row>
                                <v-row justify="center">

                                    <span style="font-size: 25px; color:#3364FF">
                                        {{ dataPendientesRobo.Porcentajed1 }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon x-large color="#01b8aa">
                                        mdi-clock
                                    </v-icon>
                                    <span v-if="dataPendientesRobo.RobosDenunciasBanda1 != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroRobosDenuncias(5, 'Robo', 'Solo Denuncias-A Tiempo', 1)"
                                        style="font-size: 16px;  margin-top: 10px;   margin-left: 10px; ">
                                        Robo a tiempo
                                    </span>
                                    <span v-if="dataPendientesRobo.RobosDenunciasBanda1 == 0 || !permiso"
                                        style="font-size: 16px;  margin-top: 10px;   margin-left: 10px; ">
                                        Robo a tiempo
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="3" sm="3">
                                <v-row justify="center">
                                    <span v-if="dataPendientesRobo.RobosDenunciasBanda2 != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroRobosDenuncias(5, 'Robo', 'Solo Denuncias-Al límite', 2)"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesRobo.RobosDenunciasBanda2 }}
                                    </span>
                                    <span v-if="dataPendientesRobo.RobosDenunciasBanda2 == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesRobo.RobosDenunciasBanda2 }}
                                    </span>

                                </v-row>
                                <v-row justify="center">

                                    <span style="font-size: 25px; color:#3364FF">
                                        {{ dataPendientesRobo.Porcentajed2 }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon x-large color="#f2c80f">
                                        mdi-progress-clock
                                    </v-icon>
                                    <span v-if="dataPendientesRobo.RobosDenunciasBanda2 != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroRobosDenuncias(5, 'Robo', 'Solo Denuncias-Al límite', 2)"
                                        style="font-size: 16px; margin-top: 10px;   margin-left: 10px;  ">
                                        Robo al limite
                                    </span>
                                    <span v-if="dataPendientesRobo.RobosDenunciasBanda2 == 0 || !permiso"
                                        style="font-size: 16px;  margin-top: 10px;   margin-left: 10px; ">
                                        Robo al limite
                                    </span>
                                </v-row>
                            </v-col>

                            <v-col cols="3" sm="3">
                                <v-row justify="center">

                                    <span v-if="dataPendientesRobo.RobosDenunciasBanda3 != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroRobosDenuncias(5, 'Robo', 'Solo Denuncias-Fuera 15 días', 3)"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesRobo.RobosDenunciasBanda3 }}
                                    </span>
                                    <span v-if="dataPendientesRobo.RobosDenunciasBanda3 == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesRobo.RobosDenunciasBanda3 }}
                                    </span>
                                </v-row>
                                <v-row justify="center">

                                    <span style="font-size: 25px; color:#3364FF">
                                        {{ dataPendientesRobo.Porcentajed3 }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon x-large color="#fe9666">
                                        mdi-progress-clock
                                    </v-icon>
                                    <span v-if="dataPendientesRobo.RobosDenunciasBanda3 != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroRobosDenuncias(5, 'Robo', 'Solo Denuncias-Fuera 15 días', 3)"
                                        style="font-size: 16px; margin-top: 10px;   margin-left: 10px;  ">
                                        Robo fuera de tiempo < 15 dias </span>
                                            <span v-if="dataPendientesRobo.RobosDenunciasBanda3 == 0 || !permiso"
                                                style="font-size: 16px; margin-top: 10px;   margin-left: 10px;  ">
                                                Robo fuera de tiempo < 15 dias </span>
                                </v-row>
                            </v-col>
                            <v-col cols="3" sm="3">
                                <v-row justify="center">
                                    <span v-if="dataPendientesRobo.RobosDenunciasBanda4 != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroRobosDenuncias(5, 'Robo', 'Solo Denuncias-Fuera de tiempo', 4)"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesRobo.RobosDenunciasBanda4 }}
                                    </span>
                                    <span v-if="dataPendientesRobo.RobosDenunciasBanda4 == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesRobo.RobosDenunciasBanda4 }}
                                    </span>

                                </v-row>
                                <v-row justify="center">

                                    <span style="font-size: 25px; color:#3364FF">
                                        {{ dataPendientesRobo.Porcentajed4 }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon x-large color="#fd625e">
                                        mdi-clock-alert
                                    </v-icon>
                                    <span v-if="dataPendientesRobo.RobosDenunciasBanda4 != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroRobosDenuncias(5, 'Robo', 'Solo Denuncias-Fuera de tiempo', 4)"
                                        style="font-size: 16px; margin-top: 10px;   margin-left: 10px;   ">
                                        Robo fuera de tiempo
                                    </span>
                                    <span v-if="dataPendientesRobo.RobosDenunciasBanda4 == 0 || !permiso"
                                        style="font-size: 16px; margin-top: 10px;   margin-left: 10px;  ">
                                        Robo fuera de tiempo
                                    </span>
                                </v-row>
                            </v-col>

                        </v-row>

                        <br />

                    </v-card>

                </v-col>
            </v-row>

            <!-- ///Proceso de RLV -->
            <v-row v-if="tipo == 6 && !previewsRLVDet">
                <v-col lg=12 cols=12 style="margin: 0 auto;">
                    <v-card class=" mx-1 pt-2 primary">
                       
                        <div class="d-flex justify-space-between align-center px-4">
                            <v-list-item-title class="text-h5 mb-1 white--text" style="text-align: center;">
                                Representación Legal Vehicular
                            </v-list-item-title>

                            <div v-if="loadingExcel == false">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-on="on" v-bind="attrs"
                                               class="btnAbo" icon fab @click="DescargarExcelRLV()">
                                            <v-icon color="white" dark style="cursor: pointer !important" class="hover">
                                                mdi-file-excel-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Descargar Excel</span>
                                </v-tooltip>
                            </div>

                            <v-progress-circular v-else
                                                 color="white"
                                                 indeterminate
                                                 size="24"></v-progress-circular>
                        </div>


                    </v-card>
                </v-col>
                <v-col lg=4 sm=4 md=4 cols=4>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />

                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-row justify="center">
                                    <span v-if="dataRLV.rlv1 != 0 && permiso" class="wrexlink"
                                        @click="vistaRLV('Robo', 1)" style="font-size: 50px; color:#3364FF">
                                        {{ dataRLV.rlv1 }}
                                    </span>
                                    <span v-if="dataRLV.rlv1 == 0 || !permiso" style="font-size: 50px; color:#3364FF">
                                        {{ dataRLV.rlv1 }}
                                    </span>

                                </v-row>

                                <v-row justify="center">
                                    <v-icon color="blue">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span style="font-size: 16px;  margin-top: 10px;   margin-left: 10px; ">
                                        Robo
                                    </span>
                                </v-row>
                            </v-col>

                        </v-row>

                        <br />

                    </v-card>

                </v-col>
                <v-col lg=4 sm=4 md=4 cols=4>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-row justify="center">
                                    <span v-if="dataRLV.rlv2 != 0 && permiso" class="wrexlink"
                                        @click="vistaRLV('Denuncias Penales por Fraude', 2)"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataRLV.rlv2 }}
                                    </span>
                                    <span v-if="dataRLV.rlv2 == 0 || !permiso" style="font-size: 50px; color:#3364FF">
                                        {{ dataRLV.rlv2 }}
                                    </span>

                                </v-row>

                                <v-row justify="center">
                                    <v-icon color="blue">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span style="font-size: 16px;  margin-top: 10px;   margin-left: 10px; ">
                                        Denuncias Penales por Fraude
                                    </span>
                                </v-row>
                            </v-col>

                        </v-row>
                        <br />
                    </v-card>
                </v-col>
                <v-col lg=4 sm=4 md=4 cols=4>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-row justify="center">
                                    <span v-if="dataRLV.rlv3 != 0 && permiso" class="wrexlink"
                                        @click="vistaRLV('Denuncia Penales por Abuso de Confianza', 3)"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataRLV.rlv3 }}
                                    </span>
                                    <span v-if="dataRLV.rlv3 == 0 || !permiso" style="font-size: 50px; color:#3364FF">
                                        {{ dataRLV.rlv3 }}
                                    </span>

                                </v-row>

                                <v-row justify="center">
                                    <v-icon color="blue">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span style="font-size: 16px;  margin-top: 10px;   margin-left: 10px; ">
                                        Denuncia Penales por Abuso de Confianza
                                    </span>
                                </v-row>
                            </v-col>

                        </v-row>
                        <br />
                    </v-card>
                </v-col>
                <v-col lg=4 sm=4 md=4 cols=4>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-row justify="center">
                                    <span v-if="dataRLV.rlv4 != 0 && permiso" class="wrexlink"
                                        @click="vistaRLV('Acreditar Propiedad', 5)"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataRLV.rlv4 }}
                                    </span>
                                    <span v-if="dataRLV.rlv4 == 0 || !permiso" style="font-size: 50px; color:#3364FF">
                                        {{ dataRLV.rlv4 }}
                                    </span>

                                </v-row>

                                <v-row justify="center">
                                    <v-icon color="blue">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span style="font-size: 16px;  margin-top: 10px;   margin-left: 10px; ">
                                        Acreditar Propiedad
                                    </span>
                                </v-row>
                            </v-col>

                        </v-row>
                        <br />
                    </v-card>
                </v-col>
                <v-col lg=4 sm=4 md=4 cols=4>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-row justify="center">
                                    <span v-if="dataRLV.rlv5 != 0 && permiso" class="wrexlink"
                                        @click="vistaRLV('Citatorios', 7)" style="font-size: 50px; color:#3364FF">
                                        {{ dataRLV.rlv5 }}
                                    </span>
                                    <span v-if="dataRLV.rlv5 == 0 || !permiso" style="font-size: 50px; color:#3364FF">
                                        {{ dataRLV.rlv5 }}
                                    </span>

                                </v-row>

                                <v-row justify="center">
                                    <v-icon color="blue">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span style="font-size: 16px;  margin-top: 10px;   margin-left: 10px; ">
                                        Citatorios
                                    </span>
                                </v-row>
                            </v-col>

                        </v-row>
                        <br />
                    </v-card>
                </v-col>
                <v-col lg=4 sm=4 md=4 cols=4>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-row justify="center">
                                    <span v-if="dataRLV.rlv6 != 0 && permiso" class="wrexlink"
                                        @click="vistaRLV('Otros', 8)" style="font-size: 50px; color:#3364FF">
                                        {{ dataRLV.rlv6 }}
                                    </span>
                                    <span v-if="dataRLV.rlv6 == 0 || !permiso" style="font-size: 50px; color:#3364FF">
                                        {{ dataRLV.rlv6 }}
                                    </span>

                                </v-row>

                                <v-row justify="center">
                                    <v-icon color="blue">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span style="font-size: 16px;  margin-top: 10px;   margin-left: 10px; ">
                                        Otros
                                    </span>
                                </v-row>
                            </v-col>

                        </v-row>
                        <br />
                    </v-card>
                </v-col>
                <v-col lg=4 sm=4 md=4 cols=4>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-row justify="center">
                                    <span v-if="dataRLV.rlv7 != 0 && permiso" class="wrexlink"
                                        @click="vistaRLV('Sin tipo de servicio', 0)"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataRLV.rlv7 }}
                                    </span>
                                    <span v-if="dataRLV.rlv7 == 0 || !permiso" style="font-size: 50px; color:#3364FF">
                                        {{ dataRLV.rlv7 }}
                                    </span>

                                </v-row>

                                <v-row justify="center">
                                    <v-icon color="blue">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span style="font-size: 16px;  margin-top: 10px;   margin-left: 10px; ">
                                        Sin tipo de servicio
                                    </span>
                                </v-row>
                            </v-col>

                        </v-row>
                        <br />
                    </v-card>
                </v-col>
            </v-row>
        </div>








        <div v-if="!previewsColisiones">
            <div class="my-2 mx-1">
                <v-btn color="error" @click="regresarPreColisiones()" dark dense>
                    <v-icon left>
                        mdi-keyboard-backspace
                    </v-icon>
                    Regresar
                </v-btn>
            </div>


            <!--HOMICIDIOS-->
            <v-row v-if="previewsHomicidios">
                <v-col lg=12 cols=12 style="margin: 0 auto;">
                    <v-card class=" mx-1 pt-2 primary">
                       
                        <div class="d-flex justify-space-between align-center px-4">
                            <v-list-item-title class="text-h5 mb-1 white--text" style="text-align: center;">
                                Homicidios
                            </v-list-item-title>

                            <div v-if="loadingExcel == false">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-on="on" v-bind="attrs"
                                               class="btnAbo" icon fab @click="DescargarExcel(3)">
                                            <v-icon color="white" dark style="cursor: pointer !important" class="hover">
                                                mdi-file-excel-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Descargar Excel</span>
                                </v-tooltip>
                            </div>

                            <v-progress-circular v-else
                                                 color="white"
                                                 indeterminate
                                                 size="24"></v-progress-circular>
                        </div>

                    </v-card>
                </v-col>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span
                                        v-if="dataPendientesColision.ColisionesMayoresHomicidiosJuicios != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMayores('Homicidios', 3, 'Juicios Orales', 'Colisiones-Mayores-Homicidios')"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresHomicidiosJuicios }}
                                    </span>
                                    <span
                                        v-if="dataPendientesColision.ColisionesMayoresHomicidiosJuicios == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresHomicidiosJuicios }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="blue">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span
                                        v-if="dataPendientesColision.ColisionesMayoresHomicidiosJuicios != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMayores('Homicidios', 3, 'Juicios Orales', 'Colisiones-Mayores-Homicidios')"
                                        style="font-size: 16px;  ">
                                        Juicios Orales
                                    </span>
                                    <span
                                        v-if="dataPendientesColision.ColisionesMayoresHomicidiosJuicios == 0 || !permiso"
                                        style="font-size: 16px;  ">
                                        Juicios Orales
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidiosAve != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMayores('Homicidios', 4, 'Averiguación Previa', 'Colisiones-Mayores-Homicidios')"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresHomicidiosAve }}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidiosAve == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresHomicidiosAve }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="red">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidiosAve != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMayores('Homicidios', 4, 'Averiguación Previa', 'Colisiones-Mayores-Homicidios')"
                                        style="font-size: 16px;  ">
                                        Averiguación Previa
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidiosAve == 0 || !permiso"
                                        style="font-size: 16px;  ">
                                        Averiguación Previa
                                    </span>
                                </v-row>
                            </v-col>
                            <!-- Nuevo Juez Civico -->
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidiosJuez != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMayores('Homicidios', 2, 'Juez Cívico Conciliador', 'Colisiones-Mayores-Homicidios')"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresHomicidiosJuez }}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidiosJuez == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresHomicidiosJuez }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="yellow">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidiosJuez != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMayores('Homicidios', 2, 'Juez Cívico Conciliador', 'Colisiones-Mayores-Homicidios')"
                                        style="font-size: 16px;  ">
                                        Juez Cívico Conciliador
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidiosJuez == 0 || !permiso"
                                        style="font-size: 16px;  ">
                                        Juez Cívico Conciliador
                                    </span>
                                </v-row>

                            </v-col>
                        </v-row>


                        <br />

                    </v-card>

                </v-col>
            </v-row>


            <!--LESIONES-->
            <v-row v-if="previewsLesiones">
                <v-col lg=12 cols=12 style="margin: 0 auto;">
                    <v-card class=" mx-1 pt-2 primary">
                        
                        <div class="d-flex justify-space-between align-center px-4">
                            <v-list-item-title class="text-h5 mb-1 white--text" style="text-align: center;">
                                Lesiones
                            </v-list-item-title>

                            <div v-if="loadingExcel == false">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-on="on" v-bind="attrs"
                                               class="btnAbo" icon fab @click="DescargarExcel(4)">
                                            <v-icon color="white" dark style="cursor: pointer !important" class="hover">
                                                mdi-file-excel-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Descargar Excel</span>
                                </v-tooltip>
                            </div>

                            <v-progress-circular v-else
                                                 color="white"
                                                 indeterminate
                                                 size="24"></v-progress-circular>
                        </div>

                    </v-card>
                </v-col>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesionesJuicios != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMayores('Lesiones', 3, 'Juicios Orales', 'Colisiones-Mayores-Lesiones')"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresLesionesJuicios }}
                                    </span>
                                    <span
                                        v-if="dataPendientesColision.ColisionesMayoresLesionesJuicios == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresLesionesJuicios }}
                                    </span>
                                </v-row>
                                <center>
                                    <v-icon color="blue">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesionesJuicios != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMayores('Lesiones', 3, 'Juicios Orales', 'Colisiones-Mayores-Lesiones')"
                                        style="font-size: 16px;  ">
                                        Juicios Orales
                                    </span>
                                    <span
                                        v-if="dataPendientesColision.ColisionesMayoresLesionesJuicios == 0 || !permiso"
                                        style="font-size: 16px;  ">
                                        Juicios Orales
                                    </span>
                                </center>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesionesAve != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMayores('Lesiones', 4, 'Averiguación Previa', 'Colisiones-Mayores-Lesiones')"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresLesionesAve }}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesionesAve == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresLesionesAve }}
                                    </span>
                                </v-row>
                                <center>
                                    <v-icon color="red">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesionesAve != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMayores('Lesiones', 4, 'Averiguación Previa', 'Colisiones-Mayores-Lesiones')"
                                        style="font-size: 16px;  ">
                                        Averiguación Previa
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesionesAve == 0 || !permiso"
                                        style="font-size: 16px;  ">
                                        Averiguación Previa
                                    </span>
                                </center>
                            </v-col>
                            <!-- Nuevo Juez Civico -->
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesionesJuez != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMayores('Lesiones', 2, 'Juez Cívico Conciliador', 'Colisiones-Mayores-Lesiones')"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresLesionesJuez }}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesionesJuez == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresLesionesJuez }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="yellow">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesionesJuez != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMayores('Lesiones', 2, 'Juez Cívico Conciliador', 'Colisiones-Mayores-Lesiones')"
                                        style="font-size: 16px;  ">
                                        Juez Cívico Conciliador
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesionesJuez == 0 || !permiso"
                                        style="font-size: 16px;  ">
                                        Juez Cívico Conciliador
                                    </span>
                                </v-row>

                            </v-col>
                        </v-row>


                        <br />

                    </v-card>

                </v-col>
            </v-row>



            <!--DAÑOS-->
            <v-row v-if="previewsDanos">
                <v-col lg=12 cols=12 style="margin: 0 auto;">
                    <v-card class=" mx-1 pt-2 primary">
                       
                        <div class="d-flex justify-space-between align-center px-4">
                            <v-list-item-title class="text-h5 mb-1 white--text" style="text-align: center;">
                                Daños
                            </v-list-item-title>

                            <div v-if="loadingExcel == false">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-on="on" v-bind="attrs"
                                               class="btnAbo" icon fab @click="DescargarExcel(5)">
                                            <v-icon color="white" dark style="cursor: pointer !important" class="hover">
                                                mdi-file-excel-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Descargar Excel</span>
                                </v-tooltip>
                            </div>

                            <v-progress-circular v-else
                                                 color="white"
                                                 indeterminate
                                                 size="24"></v-progress-circular>
                        </div>
                    </v-card>
                </v-col>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosJuicios != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMayores('Daños', 3, 'Juicios Orales', 'Colisiones-Mayores-Daños')"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresDaniosJuicios }}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosJuicios == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresDaniosJuicios }}
                                    </span>
                                </v-row>
                                <center>
                                    <v-icon color="blue">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosJuicios != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMayores('Daños', 3, 'Juicios Orales', 'Colisiones-Mayores-Daños')"
                                        style="font-size: 16px;  ">
                                        Juicios Orales
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosJuicios == 0 || !permiso"
                                        style="font-size: 16px;  ">
                                        Juicios Orales
                                    </span>
                                </center>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosAve != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMayores('Daños', 4, 'Averiguación Previa', 'Colisiones-Mayores-Daños')"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresDaniosAve }}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosAve == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresDaniosAve }}
                                    </span>
                                </v-row>
                                <center>
                                    <v-icon color="red">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosAve != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMayores('Daños', 4, 'Averiguación Previa', 'Colisiones-Mayores-Daños')"
                                        style="font-size: 16px;  ">
                                        Averiguación Previa
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosAve == 0 || !permiso"
                                        style="font-size: 16px;  ">
                                        Averiguación Previa
                                    </span>
                                </center>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosJuez != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMayores('Daños', 2, 'Juez Cívico Conciliador', 'Colisiones-Mayores-Daños')"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresDaniosJuez }}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosJuez == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesColision.ColisionesMayoresDaniosJuez }}
                                    </span>
                                </v-row>
                                <center>
                                    <v-icon color="yellow">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosJuez != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroColisionesMayores('Daños', 2, 'Juez Cívico Conciliador', 'Colisiones-Mayores-Daños')"
                                        style="font-size: 16px;  ">
                                        Juicio Cívico Conciliador
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosJuez == 0 || !permiso"
                                        style="font-size: 16px;  ">
                                        Juicio Cívico Conciliador
                                    </span>
                                </center>
                            </v-col>
                        </v-row>


                        <br />

                    </v-card>

                </v-col>
            </v-row>
        </div>

        <!--Vehiculos detenidos robo-->
        <div v-if="previewsRoboVetDet">
            <div class="my-2 mx-1">
                <v-btn color="error" @click="regresarRobo()" dark dense>
                    <v-icon left>
                        mdi-keyboard-backspace
                    </v-icon>
                    Regresar
                </v-btn>
            </div>


            <!--Vehiculos detenidos robo-->
            <v-row>
                <v-col lg=12 cols=12 style="margin: 0 auto;">
                    <v-card class=" mx-1 pt-2 primary">
                        <div class="d-flex justify-space-between align-center px-4">
                            <v-list-item-title class="text-h5 mb-1 white--text" style="text-align: center;">
                                Robo-Vehículos Detenidos
                            </v-list-item-title>

                            <div v-if="loadingExcel == false">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-on="on" v-bind="attrs"
                                               class="btnAbo" icon fab @click="DescargarExcelRobo(4)">
                                            <v-icon color="white" dark style="cursor: pointer !important" class="hover">
                                                mdi-file-excel-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Descargar Excel</span>
                                </v-tooltip>
                            </div>

                            <v-progress-circular v-else
                                                 color="white"
                                                 indeterminate
                                                 size="24"></v-progress-circular>
                        </div>

                    </v-card>
                </v-col>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="3" sm="3">
                                <v-row justify="center">
                                    <span v-if="dataPendientesRobo.Vehiculosatiempo != 0 && permiso" class="wrexlink"
                                        @click="generarTableroVHDetenidos(1, 'Robo-Veh', 'A tiempo', 1, 24)"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesRobo.Vehiculosatiempo }}
                                    </span>
                                    <span v-if="dataPendientesRobo.Vehiculosatiempo == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesRobo.Vehiculosatiempo }}
                                    </span>

                                </v-row>
                                <v-row justify="center">

                                    <span style="font-size: 25px; color:#3364FF">
                                        {{ dataPendientesRobo.Porcentaje1 }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon x-large color="#01b8aa">
                                        mdi-clock
                                    </v-icon>
                                    <span v-if="dataPendientesRobo.Vehiculosatiempo != 0 && permiso" class="wrexlink"
                                        @click="generarTableroVHDetenidos(1, 'Robo-Veh', 'Veh-A tiempo', 1, 24)"
                                        style="font-size: 16px;  margin-top: 10px;   margin-left: 10px; ">
                                        Vehículos a tiempo
                                    </span>
                                    <span v-if="dataPendientesRobo.Vehiculosatiempo == 0 || !permiso"
                                        style="font-size: 16px;  margin-top: 10px;   margin-left: 10px; ">
                                        Vehículos a tiempo
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="3" sm="3">
                                <v-row justify="center">
                                    <span v-if="dataPendientesRobo.Vehiculoslimite != 0 && permiso" class="wrexlink"
                                        @click="generarTableroVHDetenidos(1, 'Robo-Veh', 'Veh-Al límite', 2, 24)"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesRobo.Vehiculoslimite }}
                                    </span>
                                    <span v-if="dataPendientesRobo.Vehiculoslimite == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesRobo.Vehiculoslimite }}
                                    </span>

                                </v-row>
                                <v-row justify="center">

                                    <span style="font-size: 25px; color:#3364FF">
                                        {{ dataPendientesRobo.Porcentaje2 }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon x-large color="#f2c80f">
                                        mdi-progress-clock
                                    </v-icon>
                                    <span v-if="dataPendientesRobo.Vehiculoslimite != 0 && permiso" class="wrexlink"
                                        @click="generarTableroVHDetenidos(1, 'Robo-Veh', 'Veh-Al límite', 2, 24)"
                                        style="font-size: 16px; margin-top: 10px;   margin-left: 10px;  ">
                                        Vehículos al limite
                                    </span>
                                    <span v-if="dataPendientesRobo.Vehiculoslimite == 0 || !permiso"
                                        style="font-size: 16px;  margin-top: 10px;   margin-left: 10px; ">
                                        Vehículos al limite
                                    </span>
                                </v-row>
                            </v-col>

                            <v-col cols="3" sm="3">
                                <v-row justify="center">

                                    <span v-if="dataPendientesRobo.VehiculosFueraTiempo15 != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroVHDetenidos(1, 'Robo-Veh', 'Veh-Fuera 15 días', 3, 24)"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesRobo.VehiculosFueraTiempo15 }}
                                    </span>
                                    <span v-if="dataPendientesRobo.VehiculosFueraTiempo15 == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesRobo.VehiculosFueraTiempo15 }}
                                    </span>
                                </v-row>
                                <v-row justify="center">

                                    <span style="font-size: 25px; color:#3364FF">
                                        {{ dataPendientesRobo.Porcentaje3 }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon x-large color="#fe9666">
                                        mdi-progress-clock
                                    </v-icon>
                                    <span v-if="dataPendientesRobo.VehiculosFueraTiempo15 != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroVHDetenidos(1, 'Robo-Veh', 'Veh-Fuera 15 días', 3, 24)"
                                        style="font-size: 16px; margin-top: 10px;   margin-left: 10px;  ">
                                        Vehículos fuera de tiempo < 15 dias </span>
                                            <span v-if="dataPendientesRobo.VehiculosFueraTiempo15 == 0 || !permiso"
                                                style="font-size: 16px; margin-top: 10px;   margin-left: 10px;  ">
                                                Vehículos fuera de tiempo < 15 dias </span>
                                </v-row>
                            </v-col>
                            <v-col cols="3" sm="3">
                                <v-row justify="center">
                                    <span v-if="dataPendientesRobo.Vehiculosfueratiempo != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroVHDetenidos(1, 'Robo-Veh', 'Veh-Fuera de tiempo', 4, 24)"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesRobo.Vehiculosfueratiempo }}
                                    </span>
                                    <span v-if="dataPendientesRobo.Vehiculosfueratiempo == 0 || !permiso"
                                        style="font-size: 50px; color:#3364FF">
                                        {{ dataPendientesRobo.Vehiculosfueratiempo }}
                                    </span>

                                </v-row>
                                <v-row justify="center">

                                    <span style="font-size: 25px; color:#3364FF">
                                        {{ dataPendientesRobo.Porcentaje4 }}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon x-large color="#fd625e">
                                        mdi-clock-alert
                                    </v-icon>
                                    <span v-if="dataPendientesRobo.Vehiculosfueratiempo != 0 && permiso"
                                        class="wrexlink"
                                        @click="generarTableroVHDetenidos(1, 'Robo-Veh', 'Veh-Fuera de tiempo', 4, 24)"
                                        style="font-size: 16px; margin-top: 10px;   margin-left: 10px;   ">
                                        Vehículos fuera de tiempo
                                    </span>
                                    <span v-if="dataPendientesRobo.Vehiculosfueratiempo == 0 || !permiso"
                                        style="font-size: 16px; margin-top: 10px;   margin-left: 10px;  ">
                                        Vehículos fuera de tiempo
                                    </span>
                                </v-row>
                            </v-col>

                        </v-row>

                        <br />

                    </v-card>

                </v-col>
            </v-row>


        </div>


        <!--Detalle Representacion Legal-->
        <div v-if="previewsRlv">
            <div class="my-2 mx-1">
                <v-btn color="error" @click="regresarRLV()" dark dense>
                    <v-icon left>
                        mdi-keyboard-backspace
                    </v-icon>
                    Regresar
                </v-btn>
            </div>
            <v-row>
                <v-col lg=12 cols=12 style="margin: 0 auto;">
                    <v-card class=" mx-1 pt-2 primary">
                        <center>
                            <v-list-item-title class="text-h5 mb-1 primary" color="white" style="color:white">
                                {{ this.NonRLV }}
                            </v-list-item-title>
                        </center>

                    </v-card>
                    <v-card-text>
                        <div v-if="showtable">
                            <DataTable :url="urlListado" :columns="columns" :formatterActions="formatterActions"
                                :params="displayInputs" :order="[]" @apiDT="apiDT = $event"></DataTable>
                        </div>
                    </v-card-text>
                </v-col>
            </v-row>
        </div>
    </div>


</template>

<script>
import moment from 'moment';
import { mapGetters, mapState, mapMutations } from 'vuex';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import DataTable from "@/components/pages/DataTableNet/DataTable";
    import Dashboard from '@/services/Dashboard/Dashboard.service.js';
    import Archivos from '@/services/Archivos/Archivos.service.js';

export default {

    props: [
        'tipo',
        'dataPendientesColision',
        'dataPendientesRobo',
        'dataVhDetenidos',
        'dataRLV',
        'filtro'
    ],
    components: {
        DataTable
    },
    data() {
        return {
            overlay: false,
            loadingExcel: false,
            previewsColisiones: true,
            previewsHomicidios: false,
            previewsLesiones: false,
            previewsDanos: false,
            previewsRoboVetDet: false,
            previewsRobo: false,
            previewsRLVDet: false,
            previewsRlv: false,
            NonRLV: '',
            Tiporvl: 0,
            cont: 1,
            permiso: false,
            asisclae: null,
            busqueda: {
                todo: false,
                proceso: '',
                aseguradora: '',
                flotilla: '',
                estado: '',
                gerencia: '',
                supervisoria: '',
                abogado: '',
                relevancia: '',
                aiclave: '',
                vehDetTipo: null,
            },
            ////tabla
            /////////
            paginacion: [20, 50, 100],
            apiDT: null,
            show: false,
            urlListado: "Dashboard/ObtenerDetalleRLV",
            columns: [
                { name: 'reporte', data: 'reporte', title: "Reporte", formatter: [this, "detalleReporte"] },
                { name: 'svfhreporte', data: 'svfhreporte', title: "Fecha del Reporte" },
                { name: 'ainombre', data: 'ainombre', title: "Asistencia" },
                { name: 'clnombre', data: 'clnombre', title: "Cliente" },
                { name: 'flnomcomp', data: 'flnomcomp', title: "Flotilla" },
                { name: 'lonombre', data: 'lonombre', title: "Localidad" },
                { name: 'prnombre', data: 'prnombre', title: "Proveedor" },
                { name: 'supervisoria', data: 'supervisoria', title: "Supervisoria" },
                { name: "gerencia", data: "gerencia", title: "Gerencia" }
            ],
            displayInputs: {

            },
            formatterActions: [
                { click: [this, "BuscarReporte"] },
            ],
            showtable: false,

        }
    },
    computed: {
        ...mapState(['permission', 'domain']),
        ...mapGetters(['getUser', 'THEME_STATE']),
        computedDate() {
            return this.date ? moment(this.date).format('Do MMM YYYY, dddd') : ''
        },
    },
    methods: {
        ...mapMutations('Operacion', ['asignarBusqueda', 'cambiarKey', 'verificandoBusqueda']),
        
        async DescargarExcelRLV(tipo) {
            this.overlay = true;

            this.loadingExcel = true;
            this.busqueda = await MetodosGenerales.obtenerSessionReporte("BusquedaFiltrox");
            var formData3 = new FormData();

            formData3.append("data", JSON.stringify([this.busqueda]));
            formData3.append("tipo", 2);
            const response = await Dashboard.ObtenerRLVExcel(this, formData3);
            
            let today = moment().format('yyyy-MM-DD');
            let nombreArchivo = 'RLVClasificacion-' + today.toString();
            await MetodosGenerales.exportToExcel(response, nombreArchivo, true, false);
            this.overlay = false;
            this.loadingExcel = false;

            var formData = new FormData();
            formData.append("lasitio", 'Prusia+');
            formData.append("lomodulo", 'Dashboard');
            formData.append("laaccion", "Descargar Archivo excel");
            formData.append("lacaracteristicas", 'RepresentacionLegalVH');
            formData.append("lanombre", nombreArchivo + ".xlsx");
            formData.append("ladestinatario", " ");
            Archivos.AlmacenarVisitas(formData).then(data => {
            });



        },
        async DescargarExcelVH(tipo) {
            this.overlay = true;

            this.loadingExcel = true;
            this.busqueda = await MetodosGenerales.obtenerSessionReporte("BusquedaFiltrox");
                var formData3 = new FormData();

                formData3.append("data", JSON.stringify([this.busqueda]));
                formData3.append("tipo", 2);
                const response = await Dashboard.ObtenerVhDetenidosExcel(this, formData3);
                
                let today = moment().format('yyyy-MM-DD');
                let nombreArchivo = 'VehDetenidosTiempos-' + today.toString();
                await MetodosGenerales.exportToExcel(response, nombreArchivo, true, false);
                this.overlay = false;
                this.loadingExcel = false;

                var formData = new FormData();
                formData.append("lasitio", 'Prusia+');
                formData.append("lomodulo", 'Dashboard');
                formData.append("laaccion", "Descargar Archivo excel");
                formData.append("lacaracteristicas", 'Vehículos Detenidos');
                formData.append("lanombre", nombreArchivo + ".xlsx");
                formData.append("ladestinatario", " ");
                Archivos.AlmacenarVisitas(formData).then(data => {
                });



        },

        async DescargarExcelRobo(tipo) {
            this.overlay = true;
            this.busqueda = await MetodosGenerales.obtenerSessionReporte("BusquedaFiltrox");
            if (tipo == 2) {//RobosSoloDenuncias
                this.loadingExcel = true;
                var formData3 = new FormData();

                formData3.append("data", JSON.stringify([this.busqueda]));
                formData3.append("tipo", 2);
                const response = await Dashboard.ObtenerPendientesRobosExcel(this, formData3);
                
                let today = moment().format('yyyy-MM-DD');
                let nombreArchivo = 'RobosSoloDenuncias-' + today.toString();
                await MetodosGenerales.exportToExcel(response, nombreArchivo, true, false);
                this.overlay = false;
                this.loadingExcel = false;

                var formData = new FormData();
                formData.append("lasitio", 'Prusia+');
                formData.append("lomodulo", 'Dashboard');
                formData.append("laaccion", "Descargar Archivo excel");
                formData.append("lacaracteristicas", 'Pendientes');
                formData.append("lanombre", nombreArchivo + ".xlsx");
                formData.append("ladestinatario", " ");
                Archivos.AlmacenarVisitas(formData).then(data => {
                });
            }
            else if (tipo == 3) {//RobosRecuperados
                this.loadingExcel = true;
                var formData3 = new FormData();

                formData3.append("data", JSON.stringify([this.busqueda]));
                formData3.append("tipo", 3);
                const response = await Dashboard.ObtenerPendientesRobosExcel(this, formData3);
                
                let today = moment().format('yyyy-MM-DD');
                let nombreArchivo = 'RobosRecuperados-' + today.toString();
                await MetodosGenerales.exportToExcel(response, nombreArchivo, true, false);
                this.overlay = false;
                this.loadingExcel = false;

                var formData = new FormData();
                formData.append("lasitio", 'Prusia+');
                formData.append("lomodulo", 'Dashboard');
                formData.append("laaccion", "Descargar Archivo excel");
                formData.append("lacaracteristicas", 'Pendientes');
                formData.append("lanombre", nombreArchivo + ".xlsx");
                formData.append("ladestinatario", " ");
                Archivos.AlmacenarVisitas(formData).then(data => {
                });
            }
            else if (tipo == 4) {//colisiones mayores
                this.loadingExcel = true;
                var formData3 = new FormData();

                formData3.append("data", JSON.stringify([this.busqueda]));
                formData3.append("tipo", 4);
                const response = await Dashboard.ObtenerPendientesRobosExcel(this, formData3);
                
                let today = moment().format('yyyy-MM-DD');
                let nombreArchivo = 'RobosVhDetenidos-' + today.toString();
                await MetodosGenerales.exportToExcel(response, nombreArchivo, true, false);
                this.overlay = false;
                this.loadingExcel = false;

                var formData = new FormData();
                formData.append("lasitio", 'Prusia+');
                formData.append("lomodulo", 'Dashboard');
                formData.append("laaccion", "Descargar Archivo excel");
                formData.append("lacaracteristicas", 'Pendientes');
                formData.append("lanombre", nombreArchivo + ".xlsx");
                formData.append("ladestinatario", " ");
                Archivos.AlmacenarVisitas(formData).then(data => {
                });
            }
           


        },
        async DescargarExcel(tipo) {
            this.overlay = true;
            this.busqueda = await MetodosGenerales.obtenerSessionReporte("BusquedaFiltrox");
            if (tipo == 2) {//colisiones mayores
                this.loadingExcel = true;
                var formData3 = new FormData();

                formData3.append("data", JSON.stringify([this.busqueda]));
                formData3.append("tipo", 2);
                const response = await Dashboard.ObtenerPendientesColisionesExcel(this, formData3);
                
                let today = moment().format('yyyy-MM-DD');
                let nombreArchivo = 'ColisionesMayores-' + today.toString();
                await MetodosGenerales.exportToExcel(response, nombreArchivo, true, false);
                this.overlay = false;
                this.loadingExcel = false;

                var formData = new FormData();
                formData.append("lasitio", 'Prusia+');
                formData.append("lomodulo", 'Dashboard');
                formData.append("laaccion", "Descargar Archivo excel");
                formData.append("lacaracteristicas", 'Pendientes');
                formData.append("lanombre", nombreArchivo + ".xlsx");
                formData.append("ladestinatario", " ");
                Archivos.AlmacenarVisitas(formData).then(data => {
                });
            }
            else if (tipo == 3) {//colisiones mayores -Homicidios
                this.loadingExcel = true;
                var formData3 = new FormData();

                formData3.append("data", JSON.stringify([this.busqueda]));
                formData3.append("tipo", 3);
                const response = await Dashboard.ObtenerPendientesColisionesExcel(this, formData3);
                
                let today = moment().format('yyyy-MM-DD');
                let nombreArchivo = 'ColisionesMayoresHomicidios-' + today.toString();
                await MetodosGenerales.exportToExcel(response, nombreArchivo, true, false);
                this.overlay = false;
                this.loadingExcel = false;

                var formData = new FormData();
                formData.append("lasitio", 'Prusia+');
                formData.append("lomodulo", 'Dashboard');
                formData.append("laaccion", "Descargar Archivo excel");
                formData.append("lacaracteristicas", 'Pendientes');
                formData.append("lanombre", nombreArchivo + ".xlsx");
                formData.append("ladestinatario", " ");
                Archivos.AlmacenarVisitas(formData).then(data => {
                });
            }
            else if (tipo == 4) {//colisiones mayores -lesiones
                this.loadingExcel = true;
                var formData3 = new FormData();

                formData3.append("data", JSON.stringify([this.busqueda]));
                formData3.append("tipo", 4);
                const response = await Dashboard.ObtenerPendientesColisionesExcel(this, formData3);
                
                let today = moment().format('yyyy-MM-DD');
                let nombreArchivo = 'ColisionesMayoresLesiones-' + today.toString();
                await MetodosGenerales.exportToExcel(response, nombreArchivo, true, false);
                this.overlay = false;
                this.loadingExcel = false;

                var formData = new FormData();
                formData.append("lasitio", 'Prusia+');
                formData.append("lomodulo", 'Dashboard');
                formData.append("laaccion", "Descargar Archivo excel");
                formData.append("lacaracteristicas", 'Pendientes');
                formData.append("lanombre", nombreArchivo + ".xlsx");
                formData.append("ladestinatario", " ");
                Archivos.AlmacenarVisitas(formData).then(data => {
                });
            }
            else if (tipo == 5) {//colisiones mayores -daños
                this.loadingExcel = true;
                var formData3 = new FormData();

                formData3.append("data", JSON.stringify([this.busqueda]));
                formData3.append("tipo", 5);
                const response = await Dashboard.ObtenerPendientesColisionesExcel(this, formData3);
                
                let today = moment().format('yyyy-MM-DD');
                let nombreArchivo = 'ColisionesMayoresDaños-' + today.toString();
                await MetodosGenerales.exportToExcel(response, nombreArchivo, true, false);
                this.overlay = false;
                this.loadingExcel = false;

                var formData = new FormData();
                formData.append("lasitio", 'Prusia+');
                formData.append("lomodulo", 'Dashboard');
                formData.append("laaccion", "Descargar Archivo excel");
                formData.append("lacaracteristicas", 'Pendientes');
                formData.append("lanombre", nombreArchivo + ".xlsx");
                formData.append("ladestinatario", " ");
                Archivos.AlmacenarVisitas(formData).then(data => {
                });
            }
            else if (tipo == 6) {//colisiones menores
                this.loadingExcel = true;
                var formData3 = new FormData();

                formData3.append("data", JSON.stringify([this.busqueda]));
                formData3.append("tipo", 6);
                const response = await Dashboard.ObtenerPendientesColisionesExcel(this, formData3);
                
                let today = moment().format('yyyy-MM-DD');
                let nombreArchivo = 'ColisionesMenores-' + today.toString();
                await MetodosGenerales.exportToExcel(response, nombreArchivo, true, false);
                this.overlay = false;
                this.loadingExcel = false;

                var formData = new FormData();
                formData.append("lasitio", 'Prusia+');
                formData.append("lomodulo", 'Dashboard');
                formData.append("laaccion", "Descargar Archivo excel");
                formData.append("lacaracteristicas", 'Pendientes');
                formData.append("lanombre", nombreArchivo + ".xlsx");
                formData.append("ladestinatario", " ");
                Archivos.AlmacenarVisitas(formData).then(data => {
                });
            }


        },

        async generarTableroRobosDenuncias(idproceso, PTabNombre, seccion, tipo) {
            let datos;

            if (window.sessionStorage.getItem("BusquedaFiltrox") != null) {
                datos = await MetodosGenerales.obtenerSessionReporte("BusquedaFiltrox");

                if (this.cont == 1) {

                    datos.proceso = { PTabClave: idproceso, PTabNombre: PTabNombre };
                    datos.aiclave = '24';
                    datos.seccion = seccion;
                    datos.relevancia = null;
                    datos.vehDetTipo = tipo;
                    await MetodosGenerales.guardarEnSesionInfoReporte(datos, "BusquedaFiltrox");
                    this.verificandoBusqueda(false);
                    this.asignarBusqueda(datos);
                    this.cambiarKey({ tipo: 'T', key: Math.random() });

                    this.$router.push({ name: `tableroDB`, params: datos });
                }
            }
            else
                location.reload();
        },
        async generarTableroVHDetenidos(idproceso, PTabNombre, seccion, tipoKPI, asisclae) {
            let datos;
            if (window.sessionStorage.getItem("BusquedaFiltrox") != null) {
                datos = await MetodosGenerales.obtenerSessionReporte("BusquedaFiltrox");

                if (this.cont == 1) {
                    this.cont++;
                    datos.proceso = { PTabClave: idproceso, PTabNombre: PTabNombre };
                    datos.aiclave = asisclae;
                    datos.seccion = seccion;
                    datos.relevancia = null;
                    datos.vehDetTipo = tipoKPI;
                    await MetodosGenerales.guardarEnSesionInfoReporte(datos, "BusquedaFiltrox");
                    this.verificandoBusqueda(false);
                    this.asignarBusqueda(datos);
                    this.cambiarKey({ tipo: 'T', key: Math.random() });

                    this.$router.push({ name: `tableroDB`, params: datos });
                }
            }
            else
                location.reload();
        },
        async generarTableroRoboVHDetenidos(idproceso, PTabNombre, seccion) {
            let datos;
            if (window.sessionStorage.getItem("BusquedaFiltrox") != null) {
                datos = await MetodosGenerales.obtenerSessionReporte("BusquedaFiltrox");

                if (this.cont == 1) {
                    this.cont++;
                    datos.proceso = { PTabClave: idproceso, PTabNombre: PTabNombre };
                    datos.aiclave = '24';
                    datos.seccion = seccion;
                    datos.relevancia = null;
                    datos.vehDetTipo = null;
                    await MetodosGenerales.guardarEnSesionInfoReporte(datos, "BusquedaFiltrox");
                    this.verificandoBusqueda(false);
                    this.asignarBusqueda(datos);
                    this.cambiarKey({ tipo: 'T', key: Math.random() });

                    this.$router.push({ name: `tableroDB`, params: datos });
                }
            }
            else
                location.reload();
        },
        async generarTableroColisionesMayores(relevancia, idproceso, PTabNombre, seccion) {

            let datos;
            if (window.sessionStorage.getItem("BusquedaFiltrox") != null) {
                datos = await MetodosGenerales.obtenerSessionReporte("BusquedaFiltrox");

                if (relevancia == "Homicidios") {//HOMICIDIOS   3 JUICIOS ORALES, 4 AV PREVIA
                    if (this.cont == 1) {


                        datos.proceso = { PTabClave: idproceso, PTabNombre: PTabNombre };
                        datos.aiclave = '1';
                        datos.seccion = seccion;
                        datos.relevancia = { rclave: 1 };
                        datos.vehDetTipo = null;
                        await MetodosGenerales.guardarEnSesionInfoReporte(datos, "BusquedaFiltrox");
                        this.verificandoBusqueda(false);
                        this.asignarBusqueda(datos);
                        this.cambiarKey({ tipo: 'T', key: Math.random() });



                        this.cont++;
                        this.$router.push({ name: `tableroDB`, params: datos });
                    }
                }

                if (relevancia == "Lesiones") {//LESIONES
                    if (this.cont == 1) {

                        datos.proceso = { PTabClave: idproceso, PTabNombre: PTabNombre };
                        datos.aiclave = '1';
                        datos.seccion = seccion;
                        datos.relevancia = { rclave: 2 };
                        datos.vehDetTipo = null;
                        await MetodosGenerales.guardarEnSesionInfoReporte(datos, "BusquedaFiltrox");
                        this.verificandoBusqueda(false);
                        this.asignarBusqueda(datos);
                        this.cambiarKey({ tipo: 'T', key: Math.random() });

                        this.cont++;
                        this.$router.push({ name: `tableroDB`, params: datos });
                    }
                }
                if (relevancia == "Daños") {//DAÑOS
                    if (this.cont == 1) {

                        datos.proceso = { PTabClave: idproceso, PTabNombre: PTabNombre };
                        datos.aiclave = '1';
                        datos.seccion = seccion;
                        datos.relevancia = { rclave: 3 };
                        datos.vehDetTipo = null;
                        await MetodosGenerales.guardarEnSesionInfoReporte(datos, "BusquedaFiltrox");
                        this.verificandoBusqueda(false);
                        this.asignarBusqueda(datos);
                        this.cambiarKey({ tipo: 'T', key: Math.random() });

                        this.cont++;
                        this.$router.push({ name: `tableroDB`, params: datos });
                    }
                }
            }
            else
                location.reload();


        },
        async generarTableroColisionesMenores(idproceso, PTabNombre, seccion) {
            let datos;
            if (window.sessionStorage.getItem("BusquedaFiltrox") != null) {
                datos = await MetodosGenerales.obtenerSessionReporte("BusquedaFiltrox");

                if (this.cont == 1) {

                    datos.proceso = { PTabClave: idproceso, PTabNombre: PTabNombre };
                    datos.aiclave = '1';
                    datos.seccion = seccion;
                    datos.relevancia = { rclave: 0 };
                    datos.vehDetTipo = null;
                    await MetodosGenerales.guardarEnSesionInfoReporte(datos, "BusquedaFiltrox");
                    this.verificandoBusqueda(false);
                    this.asignarBusqueda(datos);
                    this.cambiarKey({ tipo: 'T', key: Math.random() });

                    this.cont++;

                    this.$router.push({ name: `tableroDB`, params: datos });
                }
            }
            else
                location.reload();
        },
        previstaColisiones(valor) {
            this.previewsColisiones = false;
            if (valor == 1) {
                this.previewsHomicidios = true;
            }
            if (valor == 2) {
                this.previewsLesiones = true;
            }
            if (valor == 3) {
                this.previewsDanos = true;
            }
        },
        regresarPreColisiones() {
            this.previewsColisiones = true;
            this.previewsHomicidios = false;
            this.previewsLesiones = false;
            this.previewsDanos = false;
        },
        vistaRobovedet() {
            this.previewsRoboVetDet = true;
            this.previewsRobo = true;
        },
        async vistaRLV(nombre, tipo) {
            this.NonRLV = nombre;
            this.Tiporvl = tipo;
            let datos;
            datos = await MetodosGenerales.obtenerSessionReporte("BusquedaFiltrox");
            datos.vehDetTipo = tipo;

            this.displayInputs = datos;
            this.previewsRLVDet = true;
            this.previewsRlv = true;
            this.showtable = true;
        },
        regresarRobo() {
            this.previewsRobo = false;
            this.previewsRoboVetDet = false;

        },
        regresarRLV() {
            this.previewsRlv = false;
            this.previewsRLVDet = false;
            this.showtable = false;


        },
        regresar() {
            this.$emit("regresardash");
        },
        detalleReporte(datos) {
            let _svindice = datos.svindice;
            let _nrreporte = datos.nrreporte;
            if ((datos.aiclave == 1 || datos.aiclave == 23 || datos.aiclave == 24 || datos.aiclave == 5)) {
                return `<div class="ml-3"><button data-action="0" data-params="${_nrreporte}" class="dt-formatterAction ma-1 reporteindice">${_nrreporte}-${_svindice}</span></button></div>`;
            } else {
                return `<span>${_nrreporte}-${_vindice}</span>`;
            }

        },
        async BuscarReporte(params, item, fila) {

            let reporte = {
                nrreporte: item.nrreporte,
                svindice: item.svindice,
                aiclave: item.aiclave,
                svfhconclusion: item.svfhconclusion
            };
            let url = '';
            let routerName = MetodosGenerales.obtenerRouterName(item.aiclave.toString());
            await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
            url = this.$router.resolve({ name: `${routerName}` });

            window.open(url.href, '_blank');

        },

    },
    async mounted() {
        this.permiso = true;
    }
}
</script>